export default __webpack_public_path__ + "static/media/horsesDk.dca5e1c0.png";